'use strict';

var angular = require('angular');
var dependencies = [];
module.exports = angular.module('AVRO.Rules.StrategyTemplatesPanel', dependencies).controller('StrategyTemplatesPanelController', require('./controllers/StrategyTemplatesPanelController')).directive('rmStrategyTemplatesPanel', require('./directives/StrategyTemplatesPanelDirective')).directive('rmStrategyTemplateThumbnail', require('./directives/StrategyTemplateThumbnailDirective'));